/**
 * the DOMContentLoaded handler runs when the document is loaded, so it can see all the elements, including <img> below.
 * But it doesn’t wait for the image to load. So alert shows zero sizes.
 */
function avvioMenu() {
  /**
   * Hamburger menu toggle active class and toggle the aria-expanded attr
   */

  let avvioHeader = document.querySelector(".avvio-header");
  let headerHeight = avvioHeader.offsetHeight;
  let avvioHeaderMenuWrapper = document.querySelector(".avvio-header__menu-wrapper");
  let avvioHeaderMenu = document.querySelector(".avvio-header__menu");
  let avvioMenuHamburger = document.querySelectorAll(".avvio-header__hamburger");
  let avvioCookiePreference = document.querySelector('a[href*="acc-cookies-panel-trigger"]');

  /**
   * Space the body based on the fixed header height
   */
  document.querySelector("body").style.paddingTop = `${headerHeight}px`;

  /**
   * Scroll menu to active navigation item
   * @function scrollMenuToActiveItem
   * @param {HTMLElement} scrollableMenuContainer - Scrollable Menu container HTML Element
   * @param {HTMLElement} element - Targeted active element, a menu will scroll to
   */
  function scrollMenuToActiveItem(scrollableMenuContainer, element) {
    if (!scrollableMenuContainer || !element) return false;

    const getOffsetTop = (element) => {
      let offsetTop = 0;
      while (element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }
      return offsetTop;
    };

    const elementOffsetTop = getOffsetTop(element);

    scrollableMenuContainer.scrollTop = elementOffsetTop;
  }

  // Close navigation menu panel on clicking outside
  function closeMenuPanelOnClickingOutside(target) {
    if (!target || !avvioHeaderMenuWrapper || !avvioMenuHamburger.length) return false;

    const closeButton = [...avvioMenuHamburger].filter((trigger) =>
      trigger.classList.contains("avvio-header__hamburger--close-menu")
    )[0];
    if (!closeButton) return false;

    const isHamburger = [...avvioMenuHamburger].some((trigger) => trigger === target);

    if (
      target !== avvioHeaderMenuWrapper &&
      !target.closest(".avvio-header__menu-wrapper") &&
      !isHamburger
    ) {
      closeMenu();
    }

    return true;
	}
	
  function activateNavigationPath(activeItem) {
    if (!activeItem) return false;

    const getTrigger = () => {
      let current = activeItem;
      const triggers = [];

      while (current && current.closest(".js-avvio-accordion")) {
        const trigger = current.querySelector(".js-avvio-accordion__trigger");
        if (trigger) {
          triggers.push(trigger);
        }

        current = current.parentNode.closest(".js-avvio-accordion");
      }

      return triggers;
    };

    const triggers = getTrigger();
    if (!triggers.length) return false;

    triggers.forEach((trigger) => {
      avvioAccordion.invokeAccordion({ target: trigger });
    });
  }

	function scrollMenuToActiveItemInit() {
    const activeItem = document.querySelector(".current-avvio-header__menu-item");
    if (!activeItem) return false;

		activateNavigationPath(activeItem);
		
		// Enable Scroll feature only for Mobile devices
		if (!avvioHeaderMenuWrapper.classList.contains("avvio-header__menu-wrapper--mobile")) return false;
		
    const scrollableMenuContainer = document.querySelector(".avvio-header__menu-wrapper");
		if (!scrollableMenuContainer) return false;
		
		const propertyMenu = activeItem.closest(".avvio-header__menu-item-level-0");
		const parentMenu = activeItem.parentNode.closest(".js-avvio-accordion");

    let element = propertyMenu;
		if (!propertyMenu) element = parentMenu;
    if (!parentMenu) element = activeItem;
    
    scrollMenuToActiveItem(scrollableMenuContainer, element);

    return true;
  }

  function closeMenu() {
    avvioHeader.classList.remove("avvio-header__menu--visible");
    setTimeout(function () {
      avvioHeaderMenu.removeAttribute("style");
    }, 1000);
  }

  /**
   * Hamburger menu activation
   */
  if (typeof avvioMenuHamburger != "undefined" && avvioMenuHamburger != null) {
    for (let hamburgerButton = 0; hamburgerButton < avvioMenuHamburger.length; hamburgerButton++) {
      /**
       * Hamburger button
       */
      let menuHamburger = avvioMenuHamburger[hamburgerButton];
      menuHamburger.addEventListener("click", avvioToggleHeaderMenu);

      function avvioToggleHeaderMenu(element) {
        if (typeof avvioHeaderMenu != "undefined" && avvioHeaderMenu != null) {
          if (element.target.classList.contains("avvio-header__hamburger--open-menu")) {
            avvioHeader.classList.add("avvio-header__menu--visible");
            avvioHeaderMenu.style.setProperty("height", `100vh`, "important");

            // Activate the menu up to the menu root and Scroll the menu to the active navigation item
            scrollMenuToActiveItemInit();
          } else if (element.target.classList.contains("avvio-header__hamburger--close-menu")) {
            closeMenu();
          }
        }
      }
    }

    document.addEventListener(
      "click",
      function (event) {
        if (
          avvioHeaderMenuWrapper.classList.contains("is-active-property-menu") &&
          !event.target.classList.contains("is-property-menu-trigger")
        ) {
          avvioHeaderMenuWrapper.classList.remove("is-active-property-menu");
        }

        if (event.target.classList.contains("is-property-menu-trigger")) {
          let submenuEl = event.target.parentElement.classList;

          if (submenuEl.contains("avvio-header__menu-item-has-property-menu")) {
            // is-active only available after the menu has been shown
            if (submenuEl.contains("is-active")) {
              // If the menu has been shown and the click event triggers, we need to hide the menu
              avvioHeaderMenuWrapper.classList.remove("is-active-property-menu");
              avvioHeader.classList.remove("avvio-header__property-menu--visible");
            } else {
              avvioHeaderMenuWrapper.classList.add("is-active-property-menu");
              avvioHeader.classList.add("avvio-header__property-menu--visible");
            }
          }
        }

        // Close navigation menu panel on clicking outside
        closeMenuPanelOnClickingOutside(event.target);
      },
      false
    );
  }

  // Avvio cookie consent tool settings hook
  if (document.body.contains(avvioCookiePreference)) {
    avvioCookiePreference.addEventListener("click", function (e) {
      e.preventDefault();
      if (typeof AvvioCC !== "undefined") AvvioCC.showMoreDetails();
    });
  }
};

/**
 * Run the menu script only on the front end
 */
//let avvioVoyagerFrontEnd = document.body.querySelector('.avvio-voyager');
let avvioVoyagerFrontEnd = document.querySelector('.avvio-voyager');
if ( typeof(avvioVoyagerFrontEnd) != 'undefined' && avvioVoyagerFrontEnd != null )
{
	document.addEventListener("DOMContentLoaded", avvioMenu());
}